import { wordCharacters } from "../fuxi/word-characters.js";
import { typedInput } from "./lianxi-yufa-item.js";

/** Clear the filled gaps when an item returns for another attempt. */
export function resetGap(form: HTMLFormElement): void {
  delete form.dataset["cbYufaKeepAnswer"];
  for (const hole of form.querySelectorAll(".cb-fuxi-hole")) {
    hole.setAttribute("aria-label", "the missing word");
  }
  for (const gap of form.querySelectorAll(".cb-fuxi-gap")) {
    gap.textContent = "";
    gap.getAnimations?.().forEach((animation) => animation.cancel());
  }
}

/** Move the submitted characters from the input into the sentence gaps. */
export function fillGap(form: HTMLFormElement, passed: boolean): void {
  if (form.dataset["cbYufaKind"] !== "gap") {
    return;
  }
  const input = typedInput(form);
  const from = input.getBoundingClientRect();
  const reduced = form.ownerDocument.defaultView?.matchMedia?.(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  for (const sentence of form.querySelectorAll<HTMLElement>(
    ".lianxi-yufa-sentence",
  )) {
    const writing =
      sentence.dataset["cbWriting"] ??
      form.ownerDocument.documentElement.dataset["cbWriting"] ??
      "zh-CN";
    const traditional = writing.includes("zh-TW") || writing.includes("zh-HK");
    const word = traditional
      ? input.dataset["cbYufaOther"]
      : input.dataset["cbYufaAnswer"];
    const characters = wordCharacters(
      passed ? (word ?? input.value.trim()) : input.value.trim(),
    );
    if (
      !passed &&
      characters.length !== sentence.querySelectorAll(".cb-fuxi-gap").length
    ) {
      form.dataset["cbYufaKeepAnswer"] = "";
      continue;
    }
    sentence
      .querySelector(".cb-fuxi-hole")
      ?.setAttribute("aria-label", characters.join(""));
    for (const [at, gap] of [
      ...sentence.querySelectorAll<HTMLElement>(".cb-fuxi-gap"),
    ].entries()) {
      const ink = form.ownerDocument.createElement("span");
      ink.className = "lianxi-yufa-gap-ink";
      if (!passed) {
        ink.classList.add("lianxi-yufa-gap-incorrect");
      }
      ink.textContent = characters[at] ?? "";
      gap.replaceChildren(ink);
      const to = gap.getBoundingClientRect();
      if (
        reduced === true ||
        to.width === 0 ||
        typeof ink.animate !== "function"
      ) {
        continue;
      }
      const startX =
        from.left +
        from.width / 2 +
        (at - (characters.length - 1) / 2) * to.width;
      ink.animate(
        [
          {
            transform: `translate(${String(startX - to.left - to.width / 2)}px, ${String(from.top + from.height / 2 - to.top - to.height / 2)}px)`,
            opacity: 0.4,
          },
          { transform: "translate(0, 0)", opacity: 1 },
        ],
        { duration: 320, easing: "ease-out" },
      );
    }
  }
}
